import { Button, Form, Space, DatePicker, Select, Input, InputNumber, Divider } from "antd";

import type { SelectProps } from "antd";

interface StepProps {
  gotoStep: Function;
  current: number;
  claimType?: "Internal" | "External";
}

const codOptions: SelectProps["options"] = [
  {
    name: "Natural",
    label: "Natural",
    value: "Natural",
  },
  {
    name: "Unnatural",
    label: "Unnatural",
    value: "Unnatural",
  },
];

const deceasedTypeOptions: SelectProps["options"] = [
  { label: "Main", value: "Main" },
  { label: "Spouse", value: "Spouse" },
  { label: "Child", value: "Child" },
  { label: "Extended", value: "Extended" },
];

const accountTypeOptions: SelectProps["options"] = [
  { label: "Savings", value: "Savings" },
  { label: "Cheque", value: "Cheque" },
  { label: "Transmission", value: "Transmission" },
];

const Details: React.FC<StepProps> = ({ gotoStep, current, claimType = "Internal" }) => {
  const isExternal = claimType === "External";
  const tailLayout = {
    labelCol: { span: 8 },
    wrapperCol: { offset: 8, span: 8 },
  };
  const fieldLayout = isExternal
    ? { labelCol: { span: 8 }, wrapperCol: { span: 12 } }
    : { wrapperCol: { offset: 8, span: 8 } };

  const content = (
    <>
      <Space
        size={"large"}
        direction="vertical"
        style={{ width: "100%", margin: "0 0 16px 0" }}
      >
        <h2
          style={{ color: "#f04f05", textAlign: "center", padding: "16px 0" }}
        >
          Details Of The Deceased.
        </h2>

        {isExternal && (
          <>
            <Form.Item
              {...fieldLayout}
              label="Name"
              name="DeceasedName"
              rules={[{ required: true, message: "Deceased name is required" }]}
            >
              <Input size="large" placeholder="Deceased name" />
            </Form.Item>
            <Form.Item
              {...fieldLayout}
              label="Surname"
              name="DeceasedSurname"
              rules={[{ required: true, message: "Deceased surname is required" }]}
            >
              <Input size="large" placeholder="Deceased surname" />
            </Form.Item>
            <Form.Item
              {...fieldLayout}
              label="ID Number"
              name="DeceasedIdNumber"
              rules={[{ required: true, message: "Deceased ID number is required" }]}
            >
              <Input size="large" placeholder="Deceased ID number" />
            </Form.Item>
            <Form.Item
              {...fieldLayout}
              label="Type"
              name="DeceasedType"
              initialValue="Main"
              rules={[{ required: true }]}
            >
              <Select size="large" options={deceasedTypeOptions} />
            </Form.Item>
          </>
        )}

        <p style={{ textAlign: "center" }}>
          Please provide date of death for the deceased.
        </p>

        <Form.Item
          name="DateOfDeath"
          {...(isExternal ? { ...fieldLayout, label: "Date Of Death" } : { wrapperCol: { offset: 8, span: 8 } })}
          rules={[
            {
              required: true,
            },
          ]}
        >
          <DatePicker
            id="Date"
            placeholder="Date Of Death"
            size="large"
            style={{ width: "100%" }}
          />
        </Form.Item>

        <p style={{ textAlign: "center" }}>Select the cause of death.</p>

        <Form.Item
          name="CauseOfDeath"
          {...(isExternal ? { ...fieldLayout, label: "Cause Of Death" } : { wrapperCol: { offset: 8, span: 8 } })}
          rules={[{ required: true }]}
        >
          <Select
            style={{ width: "100%" }}
            size="large"
            placeholder="Select Cause of Death"
            options={codOptions}
          />
        </Form.Item>

        <Form.Item
          name="Notes"
          {...(isExternal
            ? { ...fieldLayout, label: "Notes" }
            : { wrapperCol: { offset: 8, span: 8 } })}
        >
          <Input.TextArea
            rows={2}
            placeholder="Notes about the cause of death"
          />
        </Form.Item>

        {isExternal && (
          <>
            <Form.Item
              {...fieldLayout}
              label="Claim Amount"
              name="ClaimAmount"
              rules={[{ required: true, message: "Claim amount is required" }]}
            >
              <InputNumber
                size="large"
                style={{ width: "100%" }}
                min={0}
                placeholder="Claim amount"
              />
            </Form.Item>

            <Divider orientation="left">Beneficiary</Divider>
            <Form.Item
              {...fieldLayout}
              label="Beneficiary Name"
              name="BenName"
              rules={[{ required: true, message: "Beneficiary name is required" }]}
            >
              <Input size="large" placeholder="Beneficiary name" />
            </Form.Item>
            <Form.Item
              {...fieldLayout}
              label="Beneficiary Surname"
              name="BenSurname"
              rules={[{ required: true, message: "Beneficiary surname is required" }]}
            >
              <Input size="large" placeholder="Beneficiary surname" />
            </Form.Item>
            <Form.Item
              {...fieldLayout}
              label="Beneficiary ID Number"
              name="BenIdNumber"
              rules={[{ required: true, message: "Beneficiary ID number is required" }]}
            >
              <Input size="large" placeholder="Beneficiary ID number" />
            </Form.Item>

            <Divider orientation="left">Banking Details</Divider>
            <Form.Item
              {...fieldLayout}
              label="Bank"
              name="Bank"
              rules={[{ required: true, message: "Bank is required" }]}
            >
              <Input size="large" placeholder="Bank" />
            </Form.Item>
            <Form.Item
              {...fieldLayout}
              label="Account Number"
              name="AccountNumber"
              rules={[{ required: true, message: "Account number is required" }]}
            >
              <Input size="large" placeholder="Account number" />
            </Form.Item>
            <Form.Item
              {...fieldLayout}
              label="Account Type"
              name="AccountType"
              initialValue="Savings"
              rules={[{ required: true }]}
            >
              <Select size="large" options={accountTypeOptions} />
            </Form.Item>
            <Form.Item
              {...fieldLayout}
              label="Branch Code"
              name="BranchCode"
              rules={[{ required: true, message: "Branch code is required" }]}
            >
              <Input size="large" placeholder="Branch code" />
            </Form.Item>
          </>
        )}
      </Space>

      <Form.Item {...tailLayout}>
        <Space direction="vertical" style={{ width: "100%" }}>
          <Button
            className="claim-continue-btn"
            block
            size="large"
            onClick={() => gotoStep(current + 1)}
          >
            Continue
          </Button>
        </Space>
      </Form.Item>
    </>
  );

  return content;
};

export default Details;
